var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card',{staticClass:"item",attrs:{"flat":"","tile":""}},[_c('img',{staticClass:"d-block item-img",attrs:{"src":_vm.files + _vm.img + '?resize=1&w=140',"alt":_vm.title,"width":"100%","height":"100%"}})])}
var staticRenderFns = []

export { render, staticRenderFns }